import { sendConsentLink } from '@/services/disclaimer';
import { SendConsentLinkInput, SendConsentLinkRes } from '@/types/disclaimer';
import { createMutation } from 'react-query-kit';

export const useSendConsentLink = createMutation<
  SendConsentLinkRes,
  SendConsentLinkInput,
  Error
>({
  mutationFn: async (payload: SendConsentLinkInput) => sendConsentLink(payload),
});
